/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { APPLICATION_VIEW_MASTER } from '@gh/builder-shared-data';

import { createRoute } from '@gh/builder-shared';

import { ExportOfficeComponent } from './components/office-export.component';
import { ExportOfficeBusinessService } from './resources/office-export-business.service';

const routes: Routes = [
  createRoute({
    component: ExportOfficeComponent,
    path: '',
    init: ExportOfficeBusinessService,
    auth: {
      applicationView: APPLICATION_VIEW_MASTER,
    },
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: [],
  exports: [RouterModule],
})
export class BuilderHpExportRoutingModule {
}
